import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { LogIn, User, Lock, AlertCircle, CalendarDays } from "lucide-react";

export default function LoginPage() {
  const navigate = useNavigate();
  const { login } = useAuth();

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!username.trim() || !password.trim()) return;

    try {
      setLoading(true);
      setError("");
      await login(username.trim(), password);
      navigate("/admin");
    } catch (err) {
      setError(err.message || "Giriş başarısız. Lütfen bilgilerinizi kontrol edin.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-wrapper">
      <div className="login-card">
        {/* Logo */}
        <div className="login-logo">
          <div className="login-logo-icon">
            <CalendarDays />
          </div>
          <span className="login-logo-text">YerimHazır</span>
        </div>

        <h1 className="login-title">Hoş Geldiniz</h1>
        <p className="login-subtitle">
          Yönetim paneline erişmek için giriş yapın
        </p>

        {/* Error */}
        {error && (
          <div className="login-error">
            <AlertCircle />
            <span>{error}</span>
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-form">
          <div className="form-group">
            <label className="form-label">
              <User /> Kullanıcı Adı
            </label>
            <input
              id="login-username"
              type="text"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Kullanıcı adınızı girin"
              required
              autoComplete="username"
              className="form-input"
            />
          </div>

          <div className="form-group">
            <label className="form-label">
              <Lock /> Şifre
            </label>
            <input
              id="login-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Şifrenizi girin"
              required
              autoComplete="current-password"
              className="form-input"
            />
          </div>

          <button
            id="login-submit"
            type="submit"
            className="btn-login"
            disabled={loading || !username.trim() || !password.trim()}
          >
            <LogIn />
            {loading ? "Giriş yapılıyor..." : "Giriş Yap"}
          </button>
        </form>

        <p className="login-hint">
          Demo: <strong>elite_admin</strong> / <strong>123456</strong>
        </p>
      </div>
    </div>
  );
}
